<template>
    <div class="data-source_container">
      <button class="data-source data-source--condensed" @click="toggleWidget" ref="dataSource">
        <div class="data-source_info mb-1">
          <span class="data-source_expand-icon" :class="{open: widgetIsOpen}"></span>
          <h3 v-if="!widgetIsOpen">{{allRules.name}}</h3>
          <div v-if="widgetIsOpen" >
            <svg-icon
              :icon-name="'scroll'"
              :icon-size="50"
              class="mar-top--lg" />
          </div>
        </div>
      </button>
      <transition
        :duration="450"
        @before-enter="beforeEnter"
        @enter="enter"
        @before-leave="beforeLeave">
        <div
          class="expandable"
          v-show="widgetIsOpen"
          tabindex="0">
          <div class="pad-bottom--xl pad-top--sm container">
            <div class='rule-header'>
                <span class="pos--relative edit-indicator_trigger">
                  <span class="title-input mar--0" v-if="editTitle" @click="editTitleToggle">{{allRules.name}}</span>
                  <input v-if="!editTitle" ref="titleInput" class="title-input" type="text" v-model="allRules.name" :placeholder="allRules.name" @change="editTitleComplete" @focusOut="editTitleToggle">
                  <span class="edit-indicator"><i v-show="editTitle" class='fas fa-pencil-alt'></i></span>
                </span>
                <b-alert show class="error" v-if="error.name">{{error.name}}</b-alert>
                <br />
                <span v-show="editCRM" class="pos--relative edit-indicator_trigger">
                  <span @click="editCRMToggle">{{crmName || 'CRM Not Selected'}}</span>
                  <span class="edit-indicator"><i v-show="showCrmEdit" class='fas fa-pencil-alt'></i></span>
                </span>
                <b-alert show class="error" v-if="error.connection">{{error.connection}}</b-alert>
                <span v-show="!editCRM">
                  <!-- CRM connention dropdown form -->
                  <Multiselect
                    v-bind:class="{'select-error': error.connection, 'select--multi': !error.connection}"
                    v-model='crmDefault'
                    :searchable="false"
                    track-by="crm_connection_id"
                    label="company_name"
                    :options="crmInfo"
                    placeholder="Select a CRM"
                    @input="crmInput()"
                    @focusOut="crmInput()">
                </Multiselect>
              </span>
              <br/>
              <span v-show="editObject && allRules.rule_type ==='SIMPLE'" class="pos--relative edit-indicator_trigger">
                <span @click="editObjectToggle">{{allRules.crm_object || 'Object Not Selected'}}</span>
                <span class="edit-indicator"><i v-show="editObjectToggle" class='fas fa-pencil-alt'></i></span>
              </span>
              <span v-show="!editObject">
                <!-- CRM Object dropdown Form -->
                <Multiselect
                  v-bind:class="{'select-error': error.crm_object, 'select--multi': !error.crm_object}"
                  v-model='allRules.crm_object'
                  :options="objectOptions"
                  placeholder="Select a Object"
                  @input='objectInput()'>
                </Multiselect>
              </span>
              <b-alert show class="error" v-if="error.crm_object">{{error.crm_object}}</b-alert>
            </div>
            <div v-if="allRules.rule_type ==='SIMPLE'" >
              <div class="toggle-type">
                <div class="flex flex--col">
                  <p class='flex flex-justify--flex-start heading'>Currency Type</p>
                  <div class="flex flex--row flex-justify--flex-start">
                    <input class="inline-toggle" :id="'currency_toggle_' + ruleIndex" type="checkbox" v-model='currency' @change="currencyType"/>
                    <label class="checkbox-label" :for="'currency_toggle_' + ruleIndex"></label>
                    <Multiselect
                    v-show="currency"
                    class="toggle-multiselect"
                    v-model="selectCurrencyField"
                    :options="currencyOpt"
                    track-by="name"
                    label="name"
                    selectLabel= ""
                    deselectLabel=""
                    placeholder="Select a Field"
                    v-on:input="currencyType">
                  </Multiselect>
                  </div>
                </div>
                <div class="flex flex--col">
                  <p class='flex flex-justify--flex-start heading'>Event Date</p>
                  <div class="flex flex--row flex">
                    <input class="inline-toggle" :id="'event_date_toggle_' + ruleIndex" type="checkbox" v-model='eventDate' @change="eventDateType"/>
                    <label class="checkbox-label" :for="'event_date_toggle_' + ruleIndex"></label>
                    <Multiselect
                    v-show="eventDate"
                    class="toggle-multiselect"
                    v-model="selectEventDateField"
                    :options="eventDateOpt"
                    track-by="name"
                    label="name"
                    selectLabel= ""
                    deselectLabel=""
                    placeholder="Select a Field"
                    v-on:input="eventDateType">
                  </Multiselect>
                  </div>
                </div>
                <div class="flex flex--col">
                    <p class='flex flex-justify--flex-start heading'>Dimension</p>
                    <div class="flex flex--row flex">
                      <input class="inline-toggle" :id="'dimension_toggle_' + ruleIndex" type="checkbox" v-model='dimension' @change="dimensionType"/>
                      <label class="checkbox-label" :for="'dimension_toggle_' + ruleIndex"></label>
                      <Multiselect
                      v-show="dimension"
                      class="toggle-multiselect"
                      v-model="selectDimensionField"
                      :options="dimensionOpt"
                      track-by="name"
                      label="name"
                      selectLabel= ""
                      deselectLabel=""
                      placeholder="Select a Field"
                      v-on:input="dimensionType">
                    </Multiselect>
                    </div>
                  </div>
              </div>
              <div class="flex flex-items--center mar-bottom--md"><span class="heading">If </span>
                <!-- AND/OR select dropdown form-->
                <Multiselect
                  class="min-select"
                  track-by="value"
                  label="name"
                  v-model='selectAndOr'
                  :options="optionAndOr"
                  :searchable="false"
                  :show-labels="false"
                  value='AND'
                  v-on:input="optionAndOrInput()">
                </Multiselect>
                <b-alert show class="error" v-if="error.and_or">{{error.and_or}}</b-alert>
                <span class="heading"> the following conditions are met:</span>
              </div>
              <div v-for="(data, index) in allRules.conditions" :key="data.id">
                  <StitcherAddRule
                    class="condition"
                    :ruleObject="allRules.crm_object"
                    :ruleConnection='allRules.crm_connection_id'
                    :ruleFieldOption='fieldOpt'
                    :index="index"
                    :condition='data'
                    :error="conditionError[index]"
                    @deleteCondition="deleteCondition"/>
              </div>
              <button class="plus-button plus-button--condensed mar-bottom--0" @click='addRule()'><span class="plus-button_icon">+</span></button>
              <div>
                  <button class="ghost-button" @click='simpleSOQLCheck'>Check </button>
                  <b-alert :show="dismissCountDown" class="error" v-if="simpleSoqlResponse">{{simpleSoqlResponse}}</b-alert>
              </div>
            </div>
            <div>
              <StitchRuleQuery v-if="allRules.rule_type ==='SOQL'"
                :data='allRules'
                :ruleIndex="ruleIndex"
                @validationError='check = false'
                @validated='check = true'
                ></StitchRuleQuery>
            </div>
            <div class="heading mar-top--xl pad-top--xl">
              <b-alert show class="error" v-if="error.event">{{error.event}}</b-alert>
              <b-alert show class="error" v-if="error.event">{{error.event}}</b-alert>
              <p class="mar-bottom--sm">Then send data to Adobe Analytics:</p>
              <div class="evar-select">
                <div class="evar-select_field">
                  <span class="mar-right--sm">eVar</span>
                  <Multiselect
                    v-bind:class="{'select-error-small': error.adobe_variable, 'small-multiselect': !error.adobe_variable}"
                    v-model="selectEvar"
                    track-by="id"
                    label="name"
                    placeholderText='Select eVar'
                    :options="optionEvars"
                    :loading="isLoadingEvar"
                    v-on:input="inputOptionEvars()"></Multiselect>
                </div>
                <b-alert show class="error--gray" v-if="error.adobe_variable"><i class="fas fa-exclamation-triangle"></i>  {{error.adobe_variable}}</b-alert>
              </div>
              <div class="evar-select">
                <div class="evar-select_field">
                  <span class="mar-right--sm">event</span>
                  <Multiselect
                    v-bind:class="{'select-error-small': error.adobe_event, 'small-multiselect': !error.adobe_event}"
                    v-model="selectEvent"
                    label="name"
                    track-by="id"
                    placeholderText='Select Event'
                    :options="optionEvents"
                    :loading="isLoadingEvent"
                    v-on:input="inputOptionEvents()"></Multiselect>
                </div>
                <b-alert show class="error--gray" v-if="error.adobe_event"><i class="fas fa-exclamation-triangle"></i> {{error.adobe_event}}</b-alert>
              </div>
            </div>
            <span class="flex flex-items--center flex-justify--between mar-top--lg">
              <button class="ghost-button" @click="deleteRule">Delete</button>
              <div class="flex flex-items--center">
                <button class="ghost-button" @click='cancel'>Cancel </button>
                <button class="purple-button purple-button--squished" @click="saveData('index')">Save</button>
              </div>
            </span>
          </div>
        </div>
      </transition>
    </div>
  </template>

<script>
import StitcherAddRule from '@/components/StitcherAddRule'
import StitchRuleQuery from '@/components/StitchRuleQuery'
import SVGIcon from '@/components/SVGIcon'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    StitcherAddRule,
    Multiselect,
    StitchRuleQuery,
    'svg-icon': SVGIcon
  },
  props: {
    allRules: {
      type: Object
    },
    ruleIndex: {
      type: Number
    },
    crmInfo: {
      type: Array
    },
    error: {
      type: Object
    },
    objectOptions: {
      type: Array
    },
    fieldOpt: {
      type: Array
    },
    crmName: {
      type: String
    },
    crmDefault: {
      type: Object
    },
    currencyOpt: {
      type: Array
    },
    eventDateOpt: {
      type: Array
    },
    dimensionOpt: {
      type: Array
    },
    simpleSoqlResponse: {
      type: String
    },
    optionEvars: {
      type: Array
    },
    optionEvents: {
      type: Array
    },
    isLoadingEvent: {
      type: Boolean
    },
    isLoadingEvar: {
      type: Boolean
    },
    saveResponse: {
      type: String
    },
    showCrmEdit: {
      type: Boolean
    }
  },
  data () {
    return {
      editCRM: true,
      editTitle: false,
      editObject: true,
      widgetIsOpen: false,
      check: true,
      currency: false,
      eventDate: false,
      selectAndOr: { 'name': 'All', 'value': 'and' },
      selectCurrencyField: { 'name': '', 'type': '' },
      selectEventDateField: { 'name': '', 'type': '' },
      selectDimensionField: { 'name': '', 'type': '' },
      dimension: false,
      optionAndOr: [{ 'name': 'All', 'value': 'and' }, { 'name': 'Any', 'value': 'or' }],
      dismissSecs: 10,
      dismissCountDown: 0,
      selectEvar: { 'id': '', 'name': '' },
      selectEvent: { 'id': '', 'name': '' }
    }
  },
  computed: {
    conditionError () {
      return this.error.conditions
    },
    soqlError () {
      return this.error.soql
    },
    aaConnection () {
      return this.$store.state.data.AnalyticsData
    }
  },
  created () {
    this.selectEvar.id = this.allRules.adobe_variable
    this.selectEvent.id = this.allRules.adobe_event
    if (this.allRules.and_or === 'and') {
      this.selectAndOr = { 'name': 'All', 'value': 'and' }
    } else {
      this.selectAndOr = { 'name': 'Any', 'value': 'or' }
    }
    if (this.allRules.event_type === 'currency') {
      this.currency = true
      this.selectCurrencyField.name = this.allRules.revenue_field
    }
    if (this.allRules.event_date) {
      this.eventDate = true
      this.selectEventDateField.name = this.allRules.event_date_field
    }
    if (this.allRules.evar_dim) {
      this.dimension = true
      this.selectDimensionField.name = this.allRules.evar_dim_field
    }
  },
  methods: {
    saveData () {
      this.$emit('saveData')
      setTimeout(() => {
        if (this.saveResponse) {
          this.closeWidget()
        }
      }, 500)
    },
    simpleSOQLCheck () {
      this.$emit('simpleSOQLCheck')
      this.dismissCountDown = 0
      this.showAlert()
    },
    optionAndOrInput () {
      this.allRules.and_or = this.selectAndOr.value
    },
    inputOptionEvars () {
      this.allRules.adobe_variable = this.selectEvar.id
      this.allRules.adobe_variable_name = this.selectEvar.name
    },
    inputOptionEvents () {
      this.allRules.adobe_event = this.selectEvent.id
      this.allRules.adobe_event_name = this.selectEvent.name
    },
    currencyType () {
      if (this.currency) {
        this.allRules.event_type = 'currency'
        this.allRules.revenue_field = this.selectCurrencyField.name
      } else {
        this.allRules.event_type = 'count'
        this.allRules.revenue_field = null
      }
    },
    eventDateType () {
      if (this.eventDate) {
        this.allRules.event_date = true
        this.allRules.event_date_field = this.selectEventDateField.name
      } else {
        this.allRules.event_date = false
        this.allRules.event_date_field = null
      }
    },
    dimensionType () {
      if (this.dimension) {
        this.allRules.evar_dim = true
        this.allRules.evar_dim_field = this.selectDimensionField.name
      } else {
        this.allRules.evar_dim = false
        this.allRules.evar_dim_field = null
      }
    },
    cancel () {
      this.$emit('cancel', this.ruleIndex)
      this.toggleWidget()
      this.editTitle = true
      this.editCRM = true
    },
    deleteCondition (conditionIndex) {
      this.allRules.conditions.splice(conditionIndex, 1)
      this.$store.commit('updateRule', { 'ruleIndex': this.ruleIndex, 'rule': this.allRules })
    },
    addRule () {
      this.allRules.conditions.push({ 'field': '',
        'operator': '',
        'value': '' })
    },
    editTitleToggle () {
      this.editTitle = !this.editTitle
      this.$nextTick(() => {
        if (!this.editTitle) {
          this.$refs.titleInput.focus()
          this.$refs.titleInput.select()
        }
      })
    },
    editTitleComplete () {
      this.editTitle = true
    },
    editCRMToggle () {
      // Todo:  Have discussion about this.
      if (this.showCrmEdit) {
        this.editCRM = !this.editCRM
      }
    },
    editObjectToggle () {
      this.editObject = !this.editObject
    },
    objectInput () {
      this.editObject = true
      this.$emit('objectUpdate', this.allRules.crm_object)
    },
    toggleWidget () {
      this.widgetIsOpen ? this.closeWidget() : this.openWidget()
    },
    openWidget () {
      this.widgetIsOpen = true
      this.$store.commit('updateLeaderLines')
      this.$store.dispatch('ux/spotlightElement', { element: this.$el, runAfterTurningOff: this.closeWidget })
      this.setEvarName()
      this.setEventName()
    },
    closeWidget () {
      this.widgetIsOpen = false
      this.$store.commit('updateLeaderLines')
      this.$store.dispatch('ux/turnOffSpotlight')
      this.$refs.dataSource.focus()
    },
    setEvarName () {
      if (this.selectEvar.id) {
        if (this.isLoadingEvar) {
          setTimeout(() => {
            var optionEvar = this.optionEvars
            var selectEvarId = this.selectEvar.id
            var evar = optionEvar.filter(select => select.id === selectEvarId)[0]
            this.selectEvar.name = evar.name
            this.allRules.adobe_variable_name = this.selectEvar.name
          }, 3000)
        } else {
          var optionEvar = this.optionEvars
          var selectEvarId = this.selectEvar.id
          var evar = optionEvar.filter(select => select.id === selectEvarId)[0]
          this.selectEvar.name = evar.name
          this.allRules.adobe_variable_name = this.selectEvar.name
        }
      }
    },
    setEventName () {
      if (this.selectEvent.id) {
        if (this.isLoadingEvent) {
          setTimeout(() => {
            var optionEvent = this.optionEvents
            var selectEventsId = this.selectEvent.id
            var event = optionEvent.filter(select => select.id === selectEventsId)[0]
            this.selectEvent.name = event.name
            this.allRules.adobe_event_name = this.selectEvent.name
          }, 3000)
        } else {
          var optionEvent = this.optionEvents
          var selectEventsId = this.selectEvent.id
          var event = optionEvent.filter(select => select.id === selectEventsId)[0]
          this.selectEvent.name = event.name
          this.allRules.adobe_event_name = this.selectEvent.name
        }
      }
    },
    beforeEnter: function (el) {
      el.style.maxHeight = '0'
    },
    enter: function (el) {
      el.style.maxHeight = el.scrollHeight + 'px'
      setTimeout(() => {
        el.style.maxHeight = 'none'
        el.classList.add('open')
        el.focus()
      }, 400)
    },
    beforeLeave: function (el) {
      el.style.maxHeight = el.scrollHeight + 'px'
      el.classList.remove('open')
      setTimeout(() => {
        el.style.maxHeight = '0'
      }, 50)
    },
    deleteRule () {
      this.$emit('deleteRule')
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    }
  },
  mounted () {
    if (this.allRules.new) {
      this.openWidget()
      setTimeout(() => {
        this.editTitleToggle()
      }, 500)
    }
  }
}
</script>
